































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryVehicleRequest from '@/model/request/DeliveryVehicleRequest'
import DeliveryVehicleResponse from '@/model/response/DeliveryVehicleResponse'
import FilterDeliveryVehicle from '@/components/filters/FilterDeliveryVehicle.vue'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryVehicle.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryVehicle},
})
export default class ReportsDeliveryVehicleView extends Mixins(MixinFilter) {
    filter = new DeliveryVehicleRequest()
    collection = new PageCollection(DeliveryVehicleResponse, this.filter, 10)

    AppConfig = AppConfig

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryVehicleResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryVehicle.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryVehicle.title'),
          new DeliveryVehicleResponse().$endpoint,
          this.filter,
          DeliveryVehicleResponse,
          'DeliveryVehicleResponse',
          ), 'download')
    }
  }

    async created() {
      this.collection.orderBy = 'nome'
      this.collection.asc = true
    }
}
